import React from 'react';
import { Dropdown } from '../../../components/Dropdown';
import { Menu, MenuItem } from '../../../components/Menu';
import { BlogPostCategory } from '../../../components/landingPage/BlogPost';
import Styles from './BlogPage.module.less';

const defaultCategory: BlogPostCategory = {
    slug: 'tudo',
    title: 'Tudo',
    color: 'gray',
    count: 1,
};

function getDrowpdownTitle(category: BlogPostCategory = defaultCategory) {
    return `Categoria: ${category.title}`;
}

export const CategoriesDropdown = ({
    categories,
    onSelect,
}: {
    categories: BlogPostCategory[];
    onSelect: (v: BlogPostCategory) => void;
}) => {
    const [text, setText] = React.useState(getDrowpdownTitle());
    function onClick({ key }: { key: string }) {
        const category = categories.find(c => c.slug === key)!;
        setText(getDrowpdownTitle(category));
        return onSelect(category);
    }
    return (
        <Dropdown
            arrow
            onClick={e => e.stopPropagation()}
            overlay={
                <Menu selectedKeys={[]} type="contextual" onClick={onClick}>
                    <MenuItem key={'tudo'}>Tudo</MenuItem>
                    {categories
                        .filter(c => c.count > 0)
                        .map(c => (
                            <MenuItem key={c.slug}>{c.title}</MenuItem>
                        ))}
                </Menu>
            }
            placement="bottomLeft"
            size="large"
            text={text}
            trigger={['click']}
            className={Styles.categoriesDropdown}
        />
    );
};
